import { useEffect, useState, useContext } from 'react';
import Header from '../../commons/components/header/Header';
import Select from 'react-select';
import { useHistory } from 'react-router-dom';
import DatePicker, { registerLocale } from 'react-datepicker';
import {
    ESelectCustom,
    ESelectTheme,
    EErrorMsg,
} from '../../commons/statics/controls';
import Table from '../../commons/components/table/Table';
import HttpAxios from '../../commons/hooks/http';
import { useUserMe } from '../../commons/hooks/userme';
import { AppContext } from '../../commons/context/App-context';
import ModalUser from '../../commons/components/modal/Modal-user';
import { QuestionsContextProvider } from '../../commons/context/Questions';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import enviroment from '../../enviroments/enviroment';
import { IParameters } from '../../commons/interfaces/items';
import 'react-datepicker/dist/react-datepicker.css';
import es from 'date-fns/locale/es';
import './search.scss';

registerLocale('es', es);

const optionsStatus = [
    {
        value: 0,
        label: 'Todos',
    },
    {
        value: 1,
        label: 'Enviado',
    },
    {
        value: 2,
        label: 'Pendiente',
    },
];

let params = '';
let memoParams: IParameters = {};

function Search() {
    const selectStyles = ESelectCustom;
    const selectTheme = ESelectTheme;
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(null);
    const [text, setText] = useState('');
    const [status, setStatus] = useState(optionsStatus[0]);
    const history = useHistory();
    const [userMe] = useUserMe();
    const { isLoading, changeIsLoading } = useContext(AppContext);
    const [msgError, setMsgError] = useState<string>('');
    const [isAdmin, setIsAdmin] = useState<boolean>(false);
    const [name, setName] = useState<string>(' ');
    const [data, setData] = useState([]);
    const [activePage, setActivePage] = useState(1);
    const [nextPage, setNextPage] = useState(2);
    const [totalPerPage, setTotalPerPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [parameters, setParameters] = useState<IParameters>({});
    const [searched, setSearched] = useState<boolean>(false);
    const [initLoading, setInitLoading] = useState<boolean>(true);

    const filter = (page: number = 1, isPaginated?: boolean) => {
        if (!isPaginated) {
            const rangeStart = startDate
                ? dayjs(startDate).format(enviroment.search.formatDate)
                : '';
            const rangeEnd = endDate
                ? dayjs('' + endDate).format(enviroment.search.formatDate)
                : '';

            params = `?limit=${enviroment.search.limitPerPage}&search=${
                text || ''
            }&status=${
                status ? status.value : 0
            }&range=${rangeStart}-${rangeEnd}`;
            memoParams = {
                limit: enviroment.search.limitPerPage,
                search: text || '',
                status: status ? status.value : 0,
                range: rangeStart + '-' + rangeEnd,
            };
        }

        const paramsSearch = params + `&page=${page}`;
        memoParams.page = page;

        changeIsLoading(true);
        setMsgError('');
        setSearched(false);
        HttpAxios.get('/users' + paramsSearch)
            .then((res: any) => {
                const {
                    err,
                    response = [],
                    page = 1,
                    nextpage = 2,
                    totalpages = 0,
                    totalrows = 0,
                } = res?.data || {};
                changeIsLoading(false);
                if (err) {
                    setMsgError(err);
                } else {
                    setData(response);
                    setNextPage(nextpage);
                    setActivePage(page);
                    setTotalPerPage(totalrows);
                    setTotalPages(totalpages);
                    setParameters(memoParams);
                    setSearched(true);
                    setMsgError('');
                }
            })
            .catch(() => {
                changeIsLoading(false);
                setMsgError(EErrorMsg.generic);
            });
    };

    const onChangeText = (evt: any) => {
        setText(evt.target.value);
    };

    const onChangeStatus = (evt: any) => {
        setStatus(evt);
    };

    const onChangeRange = (dates: any) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
    };

    const tableHeader = [
        'Fecha',
        'Empresa',
        'Ruc',
        'Estado',
        '% Avance',
        'Apellidos',
        'Nombres',
        'Cargo',
        'Email',
        'Telefono',
    ];

    const handlePaged = (ind: number) => {
        filter(ind, true);
    };

    const getPaged = (): number[] => {
        const num = totalPages || 1;
        let paged = [];

        for (let ind = 0; ind < num; ind++) {
            paged.push(ind + 1);
        }

        return paged;
    };

    useEffect(() => {
        let _isAdmin = userMe ? Boolean(userMe.administrador) : false;
        setIsAdmin(_isAdmin);

        if (_isAdmin) {
            const _name = userMe ? (userMe.nombre as string) : '';
            setName(_name);
            setData([]);
            setActivePage(1);
            setNextPage(2);
            setTotalPerPage(0);
            setTotalPages(0);
            setInitLoading(false);
            params = '';
        } else {
            history.push('/');
        }
    }, [userMe]);

    return (
        <>
            <QuestionsContextProvider>
                <div className="SearchFull">
                    <Header
                        initLoading={initLoading}
                        title="Búsqueda de postulaciones"
                        isOnlyHeader={true}
                        name={name}
                        progress={0}
                    ></Header>
                    <div className="Search">
                        <div className="row-4">
                            <div className="col">
                                <label className="label">
                                    Búsqueda General
                                </label>
                                <input
                                    className="input"
                                    id="text"
                                    name="text"
                                    placeholder="Ingresa la palabra de búsqueda"
                                    value={text}
                                    onChange={(evt) => onChangeText(evt)}
                                />
                            </div>
                            <div className="col">
                                <label className="label">
                                    Estado de solicitud
                                </label>
                                <Select
                                    id="state"
                                    name="state"
                                    styles={selectStyles}
                                    theme={selectTheme}
                                    placeholder="Selecciona una opción"
                                    value={status}
                                    onChange={(evt) => onChangeStatus(evt)}
                                    options={optionsStatus}
                                />
                            </div>
                            <div className="col">
                                <label className="label">Rango de fechas</label>
                                <DatePicker
                                    selected={startDate}
                                    onChange={onChangeRange}
                                    startDate={startDate}
                                    endDate={endDate}
                                    selectsRange={true}
                                    locale="es"
                                    className="input"
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="Selecione un rango de fecha"
                                />
                            </div>
                            <div className="col">
                                <label className="label empty">&nbsp;</label>
                                <button
                                    className="button buttonComplement buttonFull"
                                    onClick={() => filter()}
                                >
                                    Buscar
                                </button>
                            </div>
                        </div>
                    </div>

                    {data.length > 0 && !msgError && (
                        <Table
                            data={data}
                            header={tableHeader}
                            total={totalPerPage}
                            parameters={parameters}
                        ></Table>
                    )}

                    {!isLoading && data.length === 0 && searched && (
                        <div className="SearchContent">
                            <p>No se encontraron resultados</p>
                        </div>
                    )}

                    <div className="SearchNav">
                        {data.length > 0 && !msgError && (
                            <ul>
                                {activePage > 1 && (
                                    <li
                                        className="Arrow"
                                        onClick={() =>
                                            handlePaged(activePage - 1)
                                        }
                                    >
                                        Anterior
                                    </li>
                                )}
                                {getPaged().map((item, ind) => (
                                    <li
                                        key={'paged' + ind}
                                        className={
                                            item === activePage ? 'Active' : ''
                                        }
                                        onClick={() => handlePaged(item)}
                                    >
                                        {item}
                                    </li>
                                ))}
                                {activePage < getPaged().length && (
                                    <li
                                        className="Arrow"
                                        onClick={() =>
                                            handlePaged(activePage + 1)
                                        }
                                    >
                                        Siguiente
                                    </li>
                                )}
                            </ul>
                        )}
                        {msgError && (
                            <div className="SearchMsg">
                                <span className="helpText invalid">
                                    {msgError}
                                </span>
                            </div>
                        )}
                    </div>
                </div>
                <ModalUser />
            </QuestionsContextProvider>
        </>
    );
}

export default Search;
